/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The EmailTemplatesEmailTemplate model module.
 * @module model/EmailTemplatesEmailTemplate
 * @version v0.3
 */
export default class EmailTemplatesEmailTemplate {
  /**
   * Constructs a new <code>EmailTemplatesEmailTemplate</code>.
   * @alias module:model/EmailTemplatesEmailTemplate
   * @class
   * @param name {String} Name of the email template
   * @param subject {String} Subject line of the email template
   * @param body {String} Body content of the email template
   */
  constructor(name, subject, body) {
    this.name = name;
    this.subject = subject;
    this.body = body;
  }

  /**
   * Constructs a <code>EmailTemplatesEmailTemplate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailTemplatesEmailTemplate} obj Optional instance to populate.
   * @return {module:model/EmailTemplatesEmailTemplate} The populated <code>EmailTemplatesEmailTemplate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailTemplatesEmailTemplate();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('subject'))
        obj.subject = ApiClient.convertToType(data['subject'], 'String');
      if (data.hasOwnProperty('body'))
        obj.body = ApiClient.convertToType(data['body'], 'String');
    }
    return obj;
  }
}

/**
 * Name of the email template
 * @member {String} name
 */
EmailTemplatesEmailTemplate.prototype.name = undefined;

/**
 * Subject line of the email template
 * @member {String} subject
 */
EmailTemplatesEmailTemplate.prototype.subject = undefined;

/**
 * Body content of the email template
 * @member {String} body
 */
EmailTemplatesEmailTemplate.prototype.body = undefined;
